import { t } from "@lingui/core/macro";

import { PopUpModal } from "@whoosh/design-system/src/components/overlay/PopUpModal";
import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

type CancelBookingModalConfirmationProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirmation: () => void;
};

const CancelBookingModalConfirmation = ({
  isOpen,
  onClose,
  onConfirmation,
}: CancelBookingModalConfirmationProps) => {
  return (
    <PopUpModal
      isOpen={isOpen}
      upperTitle={t`Cancel Booking`}
      cancelText={t`No`}
      confirmText={t`Yes`}
      theme="danger"
      onClose={(confirm: boolean) => {
        if (confirm) {
          onConfirmation();
        } else {
          onClose();
        }
      }}
      content={
        <VStack>
          <Text color="text-secondary">{t`Are you sure you want to cancel this booking?`}</Text>
        </VStack>
      }
    />
  );
};

export default CancelBookingModalConfirmation;
